<template>
    <div class="navbar">
        <div
            v-if="showLogo"
            class="navbar-logo"
            :style="{ width: isCollapse ? '54px' : variables.sideBarWidth }"
        >
            <logo :collapse="isCollapse" />
        </div>

        <hamburger
            id="hamburger-container"
            :is-active="sidebar.opened"
            class="hamburger-container"
            @toggleClick="toggleSideBar"
        />

        <breadcrumb
            id="breadcrumb-container"
            class="breadcrumb-container"
        />

        <div class="right-menu">
            <!-- <template v-if="device !== 'mobile'">
                <search id="header-search" class="right-menu-item" />

                <error-log class="errLog-container right-menu-item hover-effect" />

                <screenfull id="screenfull" class="right-menu-item hover-effect" />

                <el-tooltip :content="$t('navbar.size')" effect="dark" placement="bottom">
                    <size-select id="size-select" class="right-menu-item hover-effect" />
                </el-tooltip>

                <lang-select class="right-menu-item hover-effect" />
            </template> -->

            <el-popover
                placement="top-start"
                trigger="hover"
                popper-class="navbar-user"
            >
                <div
                    slot="reference"
                    class="avatar-container right-menu-item hover-effect"
                >
                    <div class="avatar-wrapper">
                        <img
                            :src="avatar"
                            class="user-avatar"
                            v-if="avatar"
                        />
                        <i
                            class="el-icon-user-solid"
                            v-else
                        />
                        <span class="user-phone">{{ account }}</span>
                        <i class="el-icon-caret-bottom" />
                    </div>
                </div>
                <div>
                    <ul class="user-info">
                        <!-- 账号 -->
                        <li class="info-item">{{ $t("navbar.account") }}：{{ account }}</li>
                        <!-- 企业用户 -->
                        <li class="info-item">
                            <div class="user-type">{{ $t("navbar.businessUsers") }}</div>
                        </li>
                        <!-- 用户名称 -->
                        <li class="info-item">{{ $t("navbar.userName") }}：{{ name }}</li>
                        <!-- 当前角色 -->
                        <li class="info-item">{{ $t("navbar.currentRole") }}：{{ roles.join("/") }}</li>
                    </ul>
                    <div class="buttons">
                        <!-- 个人信息 -->
                        <div>
                            <el-button
                                class="button"
                                size="mini"
                                @click="getPerInfo"
                            >{{ $t("navbar.personalInformation") }}</el-button>
                        </div>
                        <!-- 修改密码 -->
                        <div>
                            <el-button
                                class="button"
                                size="mini"
                                @click="restPwd"
                            >{{ $t("navbar.changePassword") }}</el-button>
                        </div>
                        <!-- 退出登录 -->
                        <div>
                            <el-button
                                class="button"
                                size="mini"
                                type="primary"
                                @click="logout"
                            >{{ $t("navbar.logOut") }}</el-button>
                        </div>
                    </div>
                </div>
            </el-popover>
        </div>
        <!-- 个人信息 -->
        <div v-if="userInfoVisble">
            <el-dialog
                top="15vh"
                width="650px"
                append-to-body
                :visible.sync="userInfoVisble"
                :title="$t('navbar.personalInformation')"
                :close-on-click-modal="false"
            >
                <UserInfo
                    :visible.sync="userInfoVisble"
                    @updataPersonInfo="updataPersonInfo"
                ></UserInfo>
            </el-dialog>
        </div>
        <!-- 修改密码 -->
        <div v-if="restPwdVisble">
            <el-dialog
                top="15vh"
                width="600px"
                append-to-body
                :visible.sync="restPwdVisble"
                :title="$t('navbar.changePassword')"
                :close-on-click-modal="false"
            >
                <ResetPwd
                    v-if="isChangPassword"
                    @restPwdConfirmRole="restPwdConfirmRole"
                    @cancel="cancel"
                ></ResetPwd>
                <div
                    v-else
                    style="min-height: 100px; text-align: center; line-height: 80px"
                >{{ $t("navbar.tip_notChangePassword") }}</div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
// import Breadcrumb from "@/components/Breadcrumb";
import Breadcrumb from "@/components/TtaBreadcrumb/index";
import Hamburger from "@/components/Hamburger/index";
import Logo from "../Sidebar/Logo";
import variables from "@/styles/variables.scss";
// import ErrorLog from "@/components/ErrorLog/index";
// import Screenfull from "@/components/Screenfull/index";
// import SizeSelect from "@/components/SizeSelect/index";
// import LangSelect from "@/components/LangSelect/index";
// import Search from "@/components/HeaderSearch/index";
import ResetPwd from "./components/resetPwd";
import UserInfo from "./components/userInfo";
import { recoverPassword, changeUserInfo } from "@/api/user-manage";
export default {
    components: {
        Breadcrumb,
        Hamburger,
        Logo,
        // ErrorLog,
        // Screenfull,
        // SizeSelect,
        // LangSelect,
        // Search,
        UserInfo,
        ResetPwd,
    },
    computed: {
        ...mapGetters(["sidebar", "avatar", "name", "roles", "device"]),
        ...mapState({
            isChangPassword: (state) => state.user.isChangPassword,
            account: (state) => state.user.account,
        }),
        showLogo() {
            return this.$store.state.settings.sidebarLogo;
        },
        isCollapse() {
            return !this.sidebar.opened;
        },
        variables() {
            return variables;
        },
    },
    data() {
        return {
            userInfoVisble: false,
            restPwdVisble: false,
        };
    },
    methods: {
        cancel() {
            this.restPwdVisble = false;
        },
        //更新个人信息
        updataPersonInfo(data) {
            let obj = new FormData();
            for (const key in data) {
                obj.append(key, data[key]);
            }
            changeUserInfo(obj).then((res) => {
                if (res.data.state == 1) {
                    this.userInfoVisble = false;
                    this.$message({
                        showClose: true,
                        message: this.$t("userManage.editSuccessTip"),
                        type: "success",
                    });
                }
            });
        },
        restPwdConfirmRole(data) {
            let obj = new FormData();
            for (const key in data) {
                obj.append(key, data[key]);
            }
            recoverPassword(obj).then((res) => {
                if (res.data.state == 1) {
                    this.restPwdVisble = false;
                }
            });
        },
        restPwd() {
            this.restPwdVisble = true;
        },
        getPerInfo() {
            this.userInfoVisble = true;
        },
        toggleSideBar() {
            this.$store.dispatch("app/toggleSideBar");
        },
        async logout() {
            await this.$store.dispatch("user/logout");
            this.$router.push(`/login?redirect=${this.$route.fullPath}`);
        },
    },
};
</script>

<style lang="scss" scoped>
.navbar {
    height: 50px;
    overflow: hidden;
    position: relative;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

    .navbar-logo {
        float: left;
        height: 50px;
        overflow: hidden;
        transition: width 0.28s;
    }

    .hamburger-container {
        line-height: 46px;
        height: 100%;
        float: left;
        cursor: pointer;
        transition: background 0.3s;
        -webkit-tap-highlight-color: transparent;

        &:hover {
            background: rgba(0, 0, 0, 0.025);
        }
    }

    .breadcrumb-container {
        float: left;
    }

    .errLog-container {
        display: inline-block;
        vertical-align: top;
    }

    .right-menu {
        float: right;
        height: 100%;
        line-height: 50px;

        &:focus {
            outline: none;
        }

        .right-menu-item {
            display: inline-block;
            padding: 0 8px;
            height: 100%;
            font-size: 18px;
            color: #5a5e66;
            // vertical-align: text-bottom;

            &.hover-effect {
                cursor: pointer;
                transition: background 0.3s;

                &:hover {
                    background: rgba(0, 0, 0, 0.025);
                }
            }
        }

        .avatar-container {
            margin-right: 30px;

            .avatar-wrapper {
                display: flex;
                align-items: center;
                height: 100%;
                position: relative;
                vertical-align: middle;

                .user-avatar {
                    cursor: pointer;
                    width: 40px;
                    height: 40px;
                    border-radius: 10px;
                }

                .el-icon-user-solid {
                    font-size: 26px;
                }

                .user-phone {
                    margin-left: 5px;
                    font-size: 14px;
                }

                .el-icon-caret-bottom {
                    cursor: pointer;
                    font-size: 12px;
                    margin-left: 5px;
                }
            }
        }
    }
}
</style>

<style lang="scss">
.el-popover.navbar-user {
    .user-info {
        max-width: 200px;
        font-size: 12px;
        line-height: 22px;
        border-bottom: 1px solid rgb(189, 188, 188);
        padding-bottom: 5px;
        .user-type {
            display: inline-block;
            border: 1px solid #1890ff;
            padding: 0 10px;
            color: #1890ff;
            border-radius: 10px;
        }
    }
    .buttons {
        margin-top: 10px;
        text-align: center;
        .button {
            margin: 5px 0;
            width: 90%;
        }
    }
}
</style>
